export default "__VITE_ASSET__C3o2yS16__"